var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Fillable, Path, PrimaryKey, RestModel } from 'ng-rest-model';
var Series = /** @class */ (function (_super) {
    __extends(Series, _super);
    function Series() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Series_1 = Series;
    Series.storeForNext = function (series) {
        this._storedForNext = series;
    };
    Series.loadForNext = function () {
        var series = Series_1._storedForNext;
        Series_1._storedForNext = null;
        return series;
    };
    Series.prototype.storeForNext = function () {
        Series_1._storedForNext = this;
    };
    __decorate([
        PrimaryKey(),
        __metadata("design:type", Number)
    ], Series.prototype, "id", void 0);
    __decorate([
        Fillable(),
        __metadata("design:type", String)
    ], Series.prototype, "title", void 0);
    __decorate([
        Fillable(),
        __metadata("design:type", String)
    ], Series.prototype, "when", void 0);
    Series = Series_1 = __decorate([
        Path('series')
    ], Series);
    return Series;
    var Series_1;
}(RestModel));
export { Series };



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/sermons/classes/series.ts.pre-build-optimizer.js